const pt = {
    "sc_title": "Centro de segurança",
    "sc_subtitle": "Camada de segurança integrada GaiaShield",
    "sc_tab_status": "🛡️ Status de proteção",
    "sc_tab_events": "📋 Log de segurança",
    "sc_tab_node": "⚙️ Segurança do nó",
    "sc_loading": "Carregando dados de segurança...",
    "sc_status_secured": "Status do sistema: Conta protegida",
    "sc_status_warning": "Status do sistema: Avisos ativos",
    "sc_desc_secured": "Não há avisos de segurança críticos ativos. O GaiaShield está monitorando ativamente sua conta.",
    "sc_desc_warning": "Atenção: Existem eventos de segurança ativos que requerem sua atenção.",
    "sc_account_protection": "Proteção de conta",
    "sc_message_protection": "Proteção de mensagens",
    "sc_audits": "Auditorias de segurança",
    "sc_active": "ATIVO",
    "sc_failed_logins": "Logins falhados",
    "sc_tamper_checks": "Verificações de adulteração",
    "sc_blocked_replays": "Replays bloqueados",
    "sc_last_check": "Última verificação",
    "sc_just_now": "Agora mesmo",
    "sc_open_warnings": "Avisos abertos",
    "sc_btn_acknowledge": "Confirmar",
    "sc_filter_severity": "Gravidade",
    "sc_filter_category": "Categoria",
    "sc_filter_hide_ack": "Ocultar confirmados",
    "sc_btn_export": "Exportar",
    "sc_col_details": "Detalhes",
    "sc_col_time": "Hora",
    "sc_col_status": "Status",
    "sc_col_action": "Ação",
    "sc_no_events": "Nenhum evento de segurança encontrado.",
    "sc_node_title": "Consola de segurança do operador de nó",
    "sc_system_health": "Saúde do sistema",
    "sc_last_audit": "Última auditoria",
    "sc_packed_logs": "Logs compactados",
    "sc_unconfirmed_events": "Eventos não confirmados",
    "sc_operator_action": "Ação do operador requerida",
    "sc_all_ok": "Tudo ok",
    "sc_critical_events": "Eventos críticos do sistema",
    "ac_title": "Centro de governança e denúncias",
    "ac_subtitle": "Consenso de governança e abuso do GaiaCom",
    "ac_tab_my_reports": "Minhas denúncias",
    "ac_tab_queue": "Fila de revisão",
    "ac_tab_operator": "Operador de nó",
    "ac_tab_transparency": "Federação e transparência",
    "ac_loading": "Carregando dados...",
    "ac_reported_cases": "Casos relatados",
    "ac_no_reports": "Ainda não submeteu nenhuma denúncia.",
    "ac_case_details": "Detalhes do caso",
    "ac_appeal_submit": "Apresentar apelação",
    "ac_appeal_status": "Status do recurso",
    "ac_appeal_reason": "Motivo do recurso",
    "ac_appeal_statement": "Declaração",
    "ac_btn_appeal": "Enviar recurso",
    "ac_trusted_reviewer_queue": "Fila de revisores confiáveis",
    "ac_case_review": "Revisar caso",
    "ac_review_category": "Categoria recomendada",
    "ac_review_severity": "Gravidade recomendada",
    "ac_review_action": "Ação recomendada",
    "ac_review_reason": "Motivo do revisor",
    "ac_btn_submit_review": "Enviar revisão",
    "ac_node_operator_dashboard": "Painel do operador de nó",
    "ac_apply_action": "Aplicar ação (Override)",
    "ac_target_type": "Tipo de alvo",
    "ac_target_id": "ID do alvo (GaiaID ou ID do canal)",
    "ac_suspend": "Suspensão ativa",
    "ac_reason": "Motivo oficial",
    "ac_btn_apply": "Impor ação",
    "ac_transparency_title": "Registro de consenso e transparência",
    "ac_transparency_desc": "Provas de snapshots visíveis publicamente de todos os canais e identidades moderados.",
    "ac_btn_snapshot": "Criar snapshot de transparência",
    "search_placeholder": "Pesquisar e-mails por assunto, remetente, texto...",
    "abuse_center_title": "Centro de abuso",
    "abbrechen": "Cancelar",
    "active_identities": "Identidades ativas",
    "active_identity": "Identidade ativa",
    "add_btn": "Adicionar",
    "add_contact_title": "Adicionar contato",
    "admin": "Administrador",
    "adressbuch": "diretório",
    "aktiviert": "Habilitado",
    "an": "Para",
    "anonymous_sender": "Remetente anônimo",
    "antworten": "Responder",
    "attachment_gaia_hint": "Os anexos do GaiaCOM permanecem criptografados de ponta a ponta.",
    "attachment_smtp_hint": "O SMTP legado bloqueia anexos executáveis/semelhantes a scripts e salva e-mails como inseguros.",
    "attachments": "Anexos",
    "auffaellig": "Perceptível",
    "auth_beta_notice": "Fase de teste beta: GaiaCOM está sendo testado ativamente. Podem ocorrer erros; proteja sementes importantes e analise cuidadosamente os fluxos de trabalho confidenciais.",
    "auth_btn_login": "Carregar identidade e fazer login",
    "auth_btn_register": "Registre-se e crie criptografia",
    "auth_copied": "Copiado",
    "auth_copy_seed": "Copiar semente",
    "auth_generate_seed": "Gerar sementes",
    "auth_headline": "GaiaCOM é o primeiro protocolo de e-mail e sistema de comunicação com segurança quântica construído para a humanidade.",
    "auth_kicker": "Comunicação segura pós-quântica",
    "auth_mnemonic": "Frase mnemônica",
    "auth_mnemonic_placeholder": "12 palavras separadas por espaços...",
    "auth_password": "senha",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "As chaves privadas não saem do seu dispositivo. Somente os destinatários pretendidos podem descriptografar o conteúdo.",
    "auth_proof_gaiadata_desc": "Conhecimento Zero: Você permanece no controle de seus dados. Os metadados são minimizados e não são usados ​​como um perfil de texto simples.",
    "auth_proof_gaiadrop_desc": "Pessoas externas podem enviar mensagens de texto confidenciais para o seu GaiaID sem uma conta.",
    "auth_proof_gaiaproof_desc": "Evidências de entrega e integridade mostram que o texto cifrado, o remetente e o carimbo de data/hora não foram adulterados.",
    "auth_proof_gaiavault_desc": "Notas privadas, notas de recuperação e registros de segurança permanecem criptografados localmente.",
    "auth_proof_hybrid_desc": "Quantum Shield: A criptografia híbrida com ML-KEM e X25519 protege contra os ataques atuais e os riscos de armazenar agora, descriptografar mais tarde.",
    "auth_secure_mail": "Correio federado seguro do Quantum",
    "auth_subline": "GaiaCOM é um sistema de comunicação quântica segura para e-mail, chat, salas de crise, GaiaDrop e arquivos de segurança locais. As chaves privadas permanecem no seu dispositivo, o conteúdo é criptografado de ponta a ponta e as evidências podem ser exportadas sem texto simples.",
    "auth_success_btn": "Faça login agora",
    "auth_success_text": "Sua conta GaiaCOM foi criada. As chaves foram derivadas localmente da sua semente e não foram armazenadas no servidor.",
    "auth_success_title": "Registro realizado com sucesso",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Login/Conta",
    "auth_toggle_login": "A conta já existe",
    "auth_toggle_register": "Criar nova conta",
    "auth_usecase_text": "Adequado para advogados, empresas, autoridades, jornalistas, denunciantes e casos de segurança privada.",
    "auth_usecase_title": "Construído para comunicação sensível",
    "auth_username": "nome de usuário",
    "auth_username_placeholder": "Digite o nome...",
    "auth_value_chat": "Bate-papo E2E",
    "auth_value_drop": "Queda segura",
    "auth_value_mail": "Correio seguro",
    "auth_value_rooms": "GaiaQuartos",
    "bestaetigen": "Confirmar",
    "bestaetigt": "Confirmado",
    "bio_status": "Biografia/Status",
    "biography": "biografia",
    "change_password_desc": "Altera sua senha de login do lado do servidor. Sua frase de recuperação local permanece protegida separadamente pela sua senha de cofre/desbloqueio.",
    "change_password_menu_desc": "Atualize a senha de login do GaiaCOM.",
    "change_password_title": "Alterar a senha",
    "channel_id": "ID do canal",
    "channel_name_label": "Nome do canal",
    "chat_deleted_hidden": "Bate-papo excluído e oculto.",
    "chat_input_placeholder": "Digite mensagem segura...",
    "chat_start_hint": "Comece a conversa! Todas as mensagens de bate-papo são criptografadas E2E com segurança quântica.",
    "choose_avatar": "Escolha o avatar",
    "ciphertext_hash": "Hash de texto cifrado",
    "clear_chat": "Bate-papo vazio",
    "clear_for_everyone": "Vazio para todos",
    "clear_for_me": "Vazio só para mim",
    "click_to_write_mail": "Clique para escrever um e-mail",
    "click_top_right": "Clique no canto superior direito",
    "close": "Fechar",
    "code_kopieren": "Copiar código",
    "code_kopieren_success": "Código copiado",
    "confirm_clear_channel_desc": "Deseja limpar este canal da sua visualização local?",
    "confirm_clear_channel_title": "Canal vazio",
    "confirm_clear_chat": "Quer esvaziar este chat?",
    "confirm_clear_chat_desc": "Quer esvaziar este chat?",
    "confirm_clear_chat_title": "Bate-papo vazio",
    "confirm_clear_everyone": "Quer esvaziar o chat para ambos os parceiros? (OK = Para todos, Cancelar = Só para mim)",
    "confirm_delete_everyone": "Deseja excluir a mensagem de ambos os parceiros? (OK = Para todos, Cancelar = Só para mim)",
    "confirm_delete_msg": "Deseja excluir esta mensagem?",
    "confirm_delete_msg_desc": "Deseja excluir esta mensagem de bate-papo?",
    "confirm_delete_msg_title": "Excluir mensagem",
    "confirm_new_password": "Confirme a nova senha",
    "copy": "Cópia",
    "create_btn": "Criar",
    "create_channel_title": "Criar canal",
    "create_group_is_crisis": "Marcar como uma área de crise",
    "create_group_title": "Criar novo grupo",
    "crypto_lock_desc": "Controla quando o GaiaCOM remove chaves criptográficas locais da memória.",
    "crypto_lock_menu_desc": "Controle os temporizadores de recarga e inatividade.",
    "crypto_lock_title": "Bloqueio criptográfico",
    "crypto_session_duration": "Desbloqueado após recarregar",
    "crypto_session_duration_desc": "Mantém a sessão criptográfica aberta apenas nesta guia do navegador durante o período selecionado.",
    "cryptographic_fingerprint": "Impressão digital criptográfica",
    "current_password": "Senha atual",
    "data_minimization": "Minimização de dados",
    "decrypt_failed": "Não decifrável",
    "delete": "Excluir",
    "delete_account_button": "Excluir conta irrevogavelmente",
    "delete_account_confirm_label": "Digite DELETE para confirmar",
    "delete_account_confirmation_error": "Senha e confirmação DELETE são necessárias.",
    "delete_account_desc": "Este modo destrói permanentemente sua conta, identidades, sessões de dispositivos, dados do GaiaDrop, metadados de upload e mensagens atribuíveis do lado do servidor.",
    "delete_account_done_desc": "Todos os dados atribuíveis do GaiaCOM foram excluídos.",
    "delete_account_done_title": "Conta excluída",
    "delete_account_menu_desc": "Destrua a conta e os dados associados.",
    "delete_account_not_authenticated": "Nenhuma conta ativa.",
    "delete_account_title": "Excluir conta",
    "delete_for_everyone": "Excluir para todos",
    "delete_for_me": "Excluir só para mim",
    "device_current": "Este dispositivo",
    "device_last_seen": "Durar",
    "device_logout": "Sair",
    "device_sessions_desc": "Verifique as sessões ativas e cancele o registro dos dispositivos nos quais você não confia mais.",
    "device_sessions_empty": "Nenhum dispositivo encontrado.",
    "device_sessions_menu_desc": "Gerenciar e encerrar sessões ativas.",
    "device_sessions_title": "Dispositivos registrados",
    "device_since": "Desde",
    "display_name": "Nome de exibição",
    "drop_address_copied": "Endereço GaiaDrop copiado.",
    "drop_btn_decrypting": "A caixa de entrada está sendo descriptografada...",
    "drop_btn_load": "Carregar caixa de entrada do GaiaDrop",
    "drop_delete_desc": "Você realmente deseja excluir permanentemente este drop?",
    "drop_delete_title": "Excluir GaiaDrop",
    "drop_desc": "Canal de envio de conhecimento zero somente texto para avisos externos, divulgação responsável e relatórios confidenciais. Partes externas podem enviar mensagens sem uma conta usando seu GaiaID.",
    "drop_empty": "Nenhuma mensagem do GaiaDrop foi carregada ainda.",
    "drop_id": "ID de descarte:",
    "drop_own_address": "Seu endereço GaiaDrop",
    "drop_proof": "À PROVA DE QUEDA",
    "drop_title": "Caixa de entrada segura GaiaDrop",
    "dunkler_modus": "Modo escuro",
    "e2e_chat_room_open": "Abra a sala de bate-papo E2E",
    "edit_profile": "Editar perfil",
    "edit_profile_desc": "Personalize o nome de exibição, biografia e avatar.",
    "einladungscode": "Código de convite",
    "enter_fingerprint_chars_confirm": "Insira os caracteres de impressão digital solicitados para confirmar.",
    "envelope_hash": "Hash de envelope",
    "erasability": "Apagabilidade",
    "erfolg": "Sucesso",
    "exclude_plaintext": "Exportar sem texto simples",
    "export_disclosure": "Exportar caso de segurança",
    "export_package_desc": "Inclua apenas texto simples se esta divulgação for intencional.",
    "export_package_title": "Exportar pacote de segurança",
    "fehler": "Erro",
    "gaiacom_reader": "Leitor GaiaCOM",
    "gaiadrop_inbox_title": "Caixa de entrada do GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimiza metadados, mantém chaves privadas locais, criptografa conteúdo de ponta a ponta e permite a exclusão completa da conta.",
    "gdpr_home_title": "100% compatível com GDPR",
    "gdpr_reason_delete": "A exclusão da conta remove contas, identidades, sessões locais e dados atribuíveis do lado do servidor.",
    "gdpr_reason_e2ee": "O conteúdo privado permanece descriptografável apenas para os destinatários pretendidos.",
    "gdpr_reason_minimal": "Os metadados são usados ​​apenas para credenciais de roteamento, entrega e segurança.",
    "gdpr_reason_zero_knowledge": "As chaves privadas e os dados de recuperação permanecem localmente sob controle do usuário.",
    "gesendet": "Enviado",
    "gesperrt_verdaechtig": "Banido / Suspeito",
    "group_delete_desc": "Você realmente deseja excluir permanentemente este grupo? Todos os canais e mensagens deste grupo serão excluídos.",
    "group_delete_title": "Excluir grupo",
    "group_description": "Descrição",
    "group_icon_label": "Ícone/avatar do grupo",
    "group_name": "Nome do grupo",
    "group_settings_avatar": "avatar",
    "group_settings_desc": "Descrição",
    "group_settings_is_crisis": "Marcar como uma área de crise",
    "group_settings_name": "Nome do grupo",
    "group_settings_title": "Configurações de grupo",
    "groups_empty_desc": "Crie um espaço de trabalho seguro para comunicação de projetos, crises ou equipes.",
    "groups_empty_title": "Ainda não há bate-papos em grupo",
    "gruppe_beitreten": "Entrou no grupo",
    "gruppe_erstellen": "+ Criar grupo",
    "gruppe_verlassen": "Sair do grupo",
    "gruppen_chats": "Bate-papos em grupo",
    "heller_modus": "Modo brilhante",
    "how_to_receive_drops": "Como recebo gotas?",
    "identitaets_assistent": "Assistente de Identidade",
    "inactivity_lock_duration": "Bloquear quando inativo",
    "inactivity_lock_duration_desc": "Após este período sem entrada, o GaiaCOM será automaticamente bloqueado criptograficamente.",
    "inactivity_lock_notice": "GaiaCOM foi bloqueado criptograficamente devido à inatividade.",
    "include_plaintext": "Incluir texto simples",
    "invite_code_label": "Código de convite",
    "join_group_title": "Junte-se ao grupo",
    "kanaele": "Canais",
    "kanal_erstellen": "+ canal",
    "kein_chat_ausgewaehlt": "Nenhum bate-papo selecionado",
    "kein_kanal_ausgewaehlt": "Nenhum canal selecionado",
    "keine_gruppe_ausgewaehlt": "Nenhum grupo selecionado",
    "keine_mails": "Nenhum e-mail disponível.",
    "key_change_warn_desc": "A chave pública deste contato foi alterada. Verifique a impressão digital antes de confiar nela.",
    "key_change_warn_title": "Aviso criptográfico",
    "key_change_warning_changed": "mudou. Isso pode ser um sinal de um ataque man-in-the-middle!",
    "key_change_warning_msg": "A chave de identidade do contato",
    "key_transparency": "Transparência Chave",
    "kopiert": "Copiado",
    "kryptographische_schluessel": "Chaves criptográficas",
    "kryptographische_schluessel_desc": "Mostrar chaves privadas e frase inicial de backup.",
    "laden": "Carregar...",
    "leeren": "Vazio",
    "loading": "Carregar...",
    "local_key_vault": "Cofre de chaves local",
    "local_keys_label": "Chaves locais",
    "lock_on_reload": "Sempre bloqueie após recarregar",
    "logout": "Sair",
    "mail_compose": "Escrever e-mail",
    "mein_profil": "Meu perfil",
    "melden": "Relatório",
    "menu": "menu",
    "message": "Notícias",
    "message_id": "ID da mensagem",
    "message_pin": "Alfinete",
    "message_pinned_title": "Mensagens fixadas",
    "message_react": "Reagir",
    "message_reply": "Responder",
    "message_replying_to": "Responder a",
    "message_save": "Salvar",
    "message_saved": "Salvo",
    "message_to_channel": "Mensagem para",
    "message_unpin": "Resolver",
    "message_unsave": "Não salve",
    "mitglied": "Membro",
    "mitglieder": "membros",
    "ml_kem": "ML-KEM",
    "neue_mail": "Novo e-mail",
    "never_auto_lock": "Nunca automaticamente",
    "new_fingerprint": "Nova impressão digital",
    "new_identity": "Nova identidade",
    "new_password": "Nova Senha",
    "no_description": "Sem descrição",
    "no_key_history": "Nenhum histórico de chave registrado.",
    "no_specification": "Não especificado",
    "old_fingerprint": "Impressão digital antiga",
    "open_privacy_imprint": "Impressão aberta e proteção de dados",
    "post_quantum_e2e": "E2E pós-quântico",
    "posteingang": "Caixa de entrada",
    "powered_by": "Distribuído por",
    "privacy_imprint_menu_desc": "Mostrar GDPR, proteção de dados e aviso legal.",
    "privacy_imprint_profile_desc": "GaiaCOM processa o conteúdo da comunicação de acordo com os princípios de minimização de dados, criptografia ponta a ponta e controle de chave local.",
    "privacy_imprint_title": "Proteção de dados e aviso legal",
    "profil": "perfil",
    "profile_details": "Detalhes do perfil",
    "profile_settings_hint": "As configurações do perfil são exibidas no painel direito.",
    "profile_unlock_desc": "Por motivos de segurança, você deve digitar novamente sua senha para visualizar suas chaves criptográficas privadas.",
    "proof_hash": "Hash de prova:",
    "public_drop_desc": "Secure Drop para informações de texto externas sem uma conta GaiaCOM.",
    "public_drop_message": "Notícias",
    "public_drop_message_placeholder": "Digite um texto confidencial...",
    "public_drop_send": "Enviar GaiaDrop",
    "public_drop_sender": "Nota do remetente opcional",
    "public_drop_sender_placeholder": "Nome, número do arquivo ou anônimo",
    "public_drop_target": "Alvo GaiaID",
    "quanten_chat": "Bate-papo Quântico",
    "quantum_secure_exchange": "Troca segura Quantum via...",
    "quantum_secure_net": "Rede segura GaiaCOM Quantum (Ed25519 e ML-KEM)",
    "quantum_shield_desc": "A rede GaiaCOM protege sua privacidade com um protocolo de criptografia híbrida multicamadas que é protegido contra ataques de futuros computadores quânticos.",
    "quantum_shield_l1_desc": "Usa o padrão FIPS 203 para encapsular uma chave compartilhada simétrica. Impede a gravação passiva e a descriptografia posterior (“Armazenar agora, descriptografar mais tarde”) por computadores quânticos.",
    "quantum_shield_l1_title": "1. Proteção Pós-Quantum (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Um procedimento clássico e extremamente rápido de troca de chaves Diffie-Hellman que serve como uma camada adicional de segurança no procedimento híbrido.",
    "quantum_shield_l2_title": "2. Criptografia de curva elíptica (X25519)",
    "quantum_shield_l3_desc": "Cada mensagem e cada envelope da Federação são assinados criptograficamente para verificar inequivocamente a autenticidade do remetente.",
    "quantum_shield_l3_title": "3. Assinaturas Digitais (Ed25519)",
    "quantum_shield_l4_desc": "Criptografa o conteúdo da mensagem de forma simétrica e vincula firmemente o remetente, o destinatário e os metadados aos Dados Adicionais Autenticados (AAD) para evitar ataques de repetição.",
    "quantum_shield_l4_title": "4. Autenticação AAD (AES-256-GCM)",
    "quantum_shield_status": "Status do Escudo Quântico",
    "receive_drops_step1": "Compartilhe seu GaiaID (por exemplo, usando o botão copiar acima) com fontes externas.",
    "receive_drops_step2": "Eles acessam a página de login da sua instância do GaiaCOM e mudam para a aba",
    "receive_drops_step3": "e envie a mensagem criptografada para o seu endereço.",
    "receiver_gaia": "Receptor GaiaCOM",
    "receiver_smtp": "Destinatário SMTP",
    "records_stored": "Registros salvos",
    "refresh": "Atualizar",
    "report_abuse_desc": "Deseja denunciar esta mensagem e enviar evidências criptográficas de abuso ao servidor?",
    "report_abuse_title": "Denunciar abuso",
    "reputation_status": "Status de reputação",
    "room_chat_start_hint": "Comece a conversa! Todas as mensagens neste canal de grupo são criptografadas E2E descentralizadas e seguras para quantum.",
    "room_policy_audit": "Trilha de auditoria e rotação de chaves ativas.",
    "room_policy_crisis": "Sala de crise",
    "room_policy_e2ee": "Espaço de conhecimento zero. E2EE quântico seguro.",
    "room_policy_title": "Diretrizes da sala",
    "room_policy_zero_knowledge": "Política",
    "room_security_note_desc": "Todas as principais alterações são validadas por meio do Key Transparency. Use GaiaVault para logs de backup privados.",
    "room_security_note_title": "Nota de segurança fixada",
    "save_profile": "Salvar perfil",
    "schluessel_entsperrt": "🔑 Bloqueie a chave novamente",
    "search_gaia_label": "Encontre o endereço de Gaia",
    "security_warning_title": "Aviso de segurança",
    "select_channel_chat": "Selecione um canal na barra lateral esquerda para conversar.",
    "select_contact_chat": "Selecione um contato no painel esquerdo para iniciar um bate-papo E2E seguro quântico.",
    "select_mail_read": "Selecione um e-mail da lista para ler seu conteúdo seguro para quantum ou criar uma nova mensagem.",
    "senden": "Enviar",
    "sender_signature": "Assinatura do remetente",
    "server_log": "Registro do servidor:",
    "server_received": "Servidor recebido",
    "session_lock": "Bloqueio de sessão",
    "setup_address_keys": "Criar endereço e conjunto de chaves",
    "setup_profile": "Configurar no perfil",
    "smtp_inbox_title": "Recepção SMTP",
    "smtp_legacy_badge": "SMTP legado/inseguro",
    "smtp_mode_option": "Ponte SMTP herdada",
    "smtp_security_warning": "Este e-mail foi transmitido através do protocolo SMTP clássico e não criptografado. Nenhuma criptografia ponta a ponta ativa.",
    "smtp_security_warning_desc": "Esta mensagem está saindo da sala de segurança do GaiaCom. A entrega SMTP não fornece garantia ponta a ponta nativa da GaiaCom, nenhuma garantia TrustMesh e nenhuma garantia Godmode do gateway.",
    "spam_verdacht": "Spam/suspeita",
    "spam_warning_desc": "Esta mensagem contém sinais de reputação suspeitos.",
    "spam_warning_title": "Aviso de spam",
    "speichern": "Salvar",
    "sperren": "Bloquear",
    "standard_group_status": "Bate-papo em grupo padrão (criptografado E2EE)",
    "status": "status",
    "subject": "A respeito de",
    "suchen": "Encontre um novo endereço em Gaia...",
    "tage": "dias",
    "time_unknown": "Hora desconhecida",
    "transmission_mode": "Modo de transferência",
    "trust_age": "Idade de confiança",
    "trust_passport_title": "Passaporte de confiança",
    "unbestaetigt": "Não confirmado",
    "unknown_sender": "Desconhecido",
    "unlock_btn": "Desbloquear",
    "unlock_btn_profile": "Desbloquear",
    "unlock_desc": "Seu arquivo de chave privada é armazenado criptografado. Digite sua senha para carregar as chaves criptográficas apenas na memória.",
    "unlock_logout": "Saia e feche as chaves locais",
    "unlock_title": "Desbloquear identidade",
    "untrusted": "Não é confiável",
    "update_password": "Atualizar senha",
    "upload_avatar_btn": "Carregar imagem (higienizada)",
    "vault_btn_encrypt": "Criptografar registro",
    "vault_btn_lock": "Bloquear seguro",
    "vault_btn_unlock": "Desbloquear com segurança",
    "vault_copied_success": "Copiado para a área de transferência",
    "vault_decrypted_content": "Conteúdo descriptografado",
    "vault_desc": "Cofre criptografado local para backups de recuperação, notas de identidade, acesso ao servidor, contatos de emergência, notas legais, eventos de segurança e registros privados.",
    "vault_empty": "Nenhum registro seguro salvo ainda.",
    "vault_locked_pane_notice": "O cofre está trancado. Por favor, desbloqueie à direita.",
    "vault_new_record": "Novo registro seguro",
    "vault_pwd_placeholder": "Digite a senha do cofre...",
    "vault_record_body": "Gravar conteúdo",
    "vault_record_body_placeholder": "Insira o conteúdo do registro criptografado...",
    "vault_record_category": "categoria",
    "vault_record_title": "Título do recorde",
    "vault_record_title_placeholder": "Título do registro seguro",
    "vault_title": "Registros seguros do GaiaVault",
    "verify_new_fingerprint_hint": "Verifique a nova impressão digital antes de aceitar a chave.",
    "vertrauenswuerdig": "Confiável",
    "vision_gaia_technology": "VisionGaiaTecnologia",
    "von": "De",
    "warnung": "aviso",
    "wizard_address": "endereço",
    "wizard_back": "Voltar",
    "wizard_check1": "Eu salvei minha semente com segurança.",
    "wizard_custom_domain": "Use seu próprio domínio",
    "wizard_desc1": "GaiaCOM não armazena chaves privadas no lado do servidor. Sem Mnemonic Seed, ninguém pode recuperar mensagens perdidas.",
    "wizard_desc2": "Seu endereço determina o nó federado através do qual os envelopes criptografados são roteados.",
    "wizard_fallback": "Nós substitutos",
    "wizard_finish": "Configuração completa",
    "wizard_next": "Avançar",
    "wizard_server_domain": "Domínio do nó do servidor",
    "wizard_step1": "1. Semente de backup",
    "wizard_step2": "2. Endereço e servidor",
    "wizard_title1": "Chave de recuperação de backup",
    "wizard_title2": "Selecione o endereço GaiaCOM",
    "write_message_placeholder": "Escreva uma mensagem segura...",
    "you": "Você",
    "zero_knowledge": "Conhecimento zero",
    "zero_knowledge_encryption": "Criptografia de conhecimento zero",
    "Chat fuer alle geleert": "O chat foi esvaziado para todos os participantes.",
    "Chat geleert": "O bate-papo foi limpo em sua caixa de entrada local.",
    "Nachricht fuer alle geloescht": "A mensagem foi excluída para todos os participantes.",
    "Nachricht geloescht": "A mensagem de bate-papo foi removida localmente da sua caixa de entrada.",
    "anpinnen": "Alfinete",
    "chat_loeschen": "Excluir bate-papo",
    "confirm_delete_chat_desc": "Tem certeza de que deseja excluir e ocultar o bate-papo?",
    "confirm_leave_group_desc": "Você realmente quer sair deste grupo?",
    "entpinnen": "Liberar",
    "group_deleted": "Grupo excluído com sucesso.",
    "group_left": "Saia do grupo com sucesso.",
    "gruppe_loeschen": "Excluir grupo",
    "loeschen": "Excluir",
    "no_active_chats": "Nenhum bate-papo ativo. Procure os contatos acima para iniciar um bate-papo.",
    "pinned": "Fixado",
    "wizard_check_credentials": "Sou responsável por manter meus dados de acesso seguros.",
    "wizard_check_is_beta": "Entendo que GaiaCom é um software beta.",
    "wizard_check_no_illegal": "Não utilizarei o GaiaCom para fins ilícitos.",
    "wizard_check_no_uptime": "Entendo que não há garantia de disponibilidade.",
    "wizard_check_smtp_security": "Entendo que as mensagens SMTP não oferecem segurança total ao GaiaCom.",
    "wizard_check_terms_read": "Eu li os Termos de Serviço do Beta.",
    "wizard_step_terms": "Termos de Uso",
    "wizard_terms_text": "Termos de uso e contrato de teste beta da GaiaCom (fase beta)\n\nProvedor: VisionGaiaTechnology (doravante denominado “Provedor”)\nStatus: fase de testes beta públicos\nValidade: A partir de 21 de junho de 2026\n\n⚠️ A NOTA MAIS IMPORTANTE ANTECIPADAMENTE (LEIA COM ATENÇÃO)\nGaiaCom está em fase de testes beta públicos. Apesar das extensas medidas de segurança, a ausência de erros, a disponibilidade contínua ou a segurança absoluta do software e da infraestrutura subjacente não podem ser garantidas. Use por sua conta e risco. Os usuários são responsáveis ​​pelo armazenamento seguro de seus dados de acesso (especialmente chaves do GaiaVault) e pelo cumprimento das leis aplicáveis.\n\n1. Objecto e finalidade da fase de teste beta\n1.1. Objetivo do fornecimento: GaiaCom é um novo serviço de e-mail e chat baseado em criptografia pós-quântica (PQC). A disponibilização durante a fase beta destina-se exclusivamente a testes técnicos, simulação de carga, localização de erros de programa (bugs) e otimização da facilidade de utilização.\n1.2. Status beta: O usuário está ciente de que o software oferecido é uma versão preliminar (software beta). Isso ainda não está totalmente desenvolvido tecnicamente, não atende aos padrões de um produto comercial final e pode causar erros, perda de dados, atrasos na transmissão ou falhas no sistema.\n1.3. Sem direito à continuação: O fornecedor tem o direito de, a qualquer momento, interromper total ou parcialmente o serviço, alterar ou restringir funções ou removê-las temporária ou permanentemente sem indicar motivos.\n\n2. Disponibilidade e Isenção de Garantia\n2.1. Sem garantia de disponibilidade: GaiaCom é fornecido sem qualquer garantia de disponibilidade ou tempo de atividade. Não há direito à disponibilidade ininterrupta do serviço.\n2.2. Exclusão de garantia: O software é fornecido no seu estado atual (“como está”) e sujeito à disponibilidade. Na medida permitida por lei, quaisquer reclamações de garantia por defeitos materiais e legais no software serão excluídas. Em particular, não há garantia de que o software esteja livre de erros, de malware ou adequado para uma finalidade específica.\n\n3. Gestão de riscos e obrigações dos usuários\n3.1. Proibição de armazenamento de dados críticos: O usuário compromete-se a não armazenar ou transmitir exclusivamente através do GaiaCom quaisquer dados críticos para o negócio, vitais, operacionalmente necessários ou legalmente particularmente sensíveis (como arquivos de pacientes, dados financeiros altamente sensíveis ou segredos oficialmente regulamentados). O serviço não pode ser utilizado em infraestruturas onde falhas imprevistas possam resultar em ferimentos pessoais, danos materiais ou perdas financeiras significativas.\n3.2. Backup auto-responsável: O usuário é responsável por fazer backup de todos os dados recebidos ou enviados via GaiaCom que necessite a longo prazo em sistemas próprios e independentes (cópias de backup). O provedor não garante o armazenamento permanente ou a capacidade de restauração dos dados em seus servidores.\n\n4. Recursos criptográficos e GaiaVault\n4.1. Criptografia pós-quântica (PQC): GaiaCom implementa processos de criptografia de última geração orientados para o futuro, projetados para resistir a ataques de futuros computadores quânticos. No entanto, o usuário está ciente de que este é um campo científico novo e dinâmico. A segurança absoluta e irrefutável não pode ser garantida com base no estado actual da ciência e da tecnologia. Termos como “100% seguro”, “inquebrável” ou “militarmente seguro” não são expressamente garantidos.\n4.2. Sem garantia de recuperação (GaiaVault): GaiaCom depende de um conceito consistente de segurança de conhecimento zero. As cunhas de criptografia e os dados de acesso permanecem sob controle exclusivo do usuário (protegidos via GaiaVault).\nIMPORTANTE: Se o usuário perder suas senhas, senhas, chaves privadas ou sementes de recuperação, o provedor não terá capacidade técnica para reconstruir ou redefinir esses dados. A perda destes dados de acesso conduz inevitavelmente à perda irrevogável de acesso à conta do utilizador e a todos os dados nela encriptados.\n4.3. Ainda não totalmente auditado: O software é continuamente submetido a verificações de segurança internas, mas no momento desta fase beta ainda não foi submetido a uma auditoria de segurança externa final e abrangente por organismos de testes independentes.\n\n5. Interfaces, protocolos legados e federação\n5.1. Nota sobre SMTP Bridge: GaiaCom oferece a capacidade de comunicação através de protocolos de e-mail clássicos (como SMTP). O usuário está ciente de que as mensagens que saem da área de segurança nativa do GaiaCom (por exemplo, quando enviadas para um endereço convencional @gmail.com ou @gmx.de) são transportadas através de servidores não criptografados ou de terceiros. As garantias de segurança ponta a ponta da GaiaCom se aplicam apenas até certo ponto ou não se aplicam a essas mensagens legadas enviadas ou recebidas externamente.\n5.2. Nota da Federação: Se a GaiaCom operar em uma rede federada, mensagens e dados poderão passar por servidores de terceiros. Embora o conteúdo das mensagens permaneça protegido por criptografia de ponta a ponta, os metadados (como hora do envio, endereços IP dos servidores envolvidos e endereços dos destinatários) podem ser tecnicamente visíveis para os operadores desses servidores federados. O provedor não tem influência nas práticas de proteção de dados de operadores de servidores terceirizados na rede federada.\n\n6. Usos aceitáveis e atividades proibidas\nO utilizador compromete-se a não utilizar o serviço de forma indevida ou para fins ilegais. Em particular, são proibidos:\n- Distribuir, enviar ou hospedar vírus, malware, conteúdo de phishing ou outro software malicioso.\n- Utilizar o Serviço para realizar ataques de negação de serviço (DDoS) ou envio de correspondência em massa não solicitada (spam).\n- Abusar do sistema para cometer fraudes.\n- A distribuição ou troca de conteúdos ilegais, em particular representações de abuso sexual infantil (CSAM), propaganda terrorista, apelos à violência ou outros conteúdos criminalmente relevantes.\n\n7. Sistema de denúncia de abusos\n7.1. Denunciar comportamento abusivo: Os usuários têm a oportunidade de denunciar comunicações abusivas ou atividades ilegais por meio do sistema integrado de abuso.\n7.2. Processamento de relatórios: Para garantir proteção contra uso indevido, os relatórios recebidos podem ser analisados ​​tecnicamente (mantendo os limites de privacidade e criptografia). Isto pode levar à suspensão temporária ou permanente de contas de usuários ou endereços IP em caso de violações comprovadas destes termos de uso.\n\n8. Limitação de Responsabilidade\n8.1. Padrão de responsabilidade: O software beta é fornecido gratuitamente. De acordo com as regras legais para doações ou empréstimos, o fornecedor só é responsável por dolo (dano intencional) e negligência grave.\n8.2. Exclusão de responsabilidade pela perda de dados: A responsabilidade pela perda de dados está excluída, a menos que a perda tenha sido causada intencionalmente ou por negligência grave do fornecedor e o utilizador tenha cumprido a sua obrigação de mitigar os danos através de backups regulares (fora da GaiaCom).\n8.3. Limites legais: As limitações de responsabilidade acima não se aplicam a danos à vida, ao corpo ou à saúde ou à responsabilidade sob a Lei de Responsabilidade do Produto.\n\n9. Código aberto\nCertos componentes, bibliotecas ou aplicativos clientes da GaiaCom podem ser licenciados sob licenças de código aberto (por exemplo, GPL, MIT, Apache). Os respectivos termos de licença desses componentes não são afetados por estes termos de uso e podem ser visualizados nos repositórios de código-fonte correspondentes.\n\n10. Controle de Exportação e Conformidade\nO usuário está ciente de que o software criptográfico pode estar sujeito a rígidos controles de exportação e restrições legais. O usuário é responsável por garantir que o uso do GaiaCom não viole as leis, restrições de importação/exportação ou regulamentos de criptografia do seu respectivo país de residência.\n\n11. Aviso de proteção de dados (versão resumida para beta)\n11.1. Coleta mínima de dados: Como parte da fase beta, o provedor coleta apenas dados absolutamente necessários para operação técnica, solução de problemas e desenvolvimento adicional (por exemplo, arquivos de log do servidor para diagnóstico de erros).\n11.2. Nenhuma visão do conteúdo: Graças ao conhecimento zero consistente e à criptografia E2E, o provedor nunca tem acesso ao conteúdo de seus chats, e-mails ou chaves armazenadas no GaiaVault.\n11.3. Declaração detalhada de proteção de dados: Os regulamentos detalhados de proteção de dados estão vinculados separadamente e também devem ser levados em consideração pelo usuário antes do registro.\n\n12. Disposições finais\n12.1. Lei aplicável: Aplica-se a lei da República Federal da Alemanha, excluindo a Convenção das Nações Unidas sobre Contratos para a Venda Internacional de Mercadorias.\n12.2. Sujeito a alterações: Dado que GaiaCom está em desenvolvimento ativo, o fornecedor reserva-se o direito de adaptar estas condições a qualquer momento com efeitos para o futuro. A versão atual está disponível no aplicativo.",
    "wizard_terms_title": "Termos de uso e contrato de teste beta da GaiaCom (fase beta)",
    "node_operator": "Operador de nó",
    "search_channels": "Pesquisar canais...",
    "senior_reviewer": "Revisor Sênior",
    "trusted_reviewer": "Revisor confiável",
    "active_frequencies": "Frequências ativas",
    "connected_rooms": "ESPAÇOS CONECTADOS",
    "dashboard": "Painel",
    "empty_chats": "Nenhum bate-papo ativo disponível.",
    "empty_messages": "Nenhuma nova mensagem disponível.",
    "encrypted": "Criptografado",
    "gaiacom_uplink": "LINK GAIACOM",
    "install_app": "Instalar aplicativo",
    "install_app_desc": "Para início rápido e modo offline",
    "kommandozentrale_alpha": "Centro de comando ALPHA",
    "network_online": "REDE: ON-LINE",
    "new_room": "Novo espaço",
    "no_frequencies_active": "Nenhuma frequência ativa. Crie uma nova sala para iniciar a comunicação.",
    "no_id": "Sem identificação",
    "open_chats": "Bate-papos abertos",
    "open_inbox": "Abrir caixa de entrada",
    "primary_identity": "IDENTIDADE PRIMÁRIA",
    "recent_chats": "Novos bate-papos",
    "recent_messages": "Últimas notícias",
    "session_encrypted": "Sessão criptografada: {nome}",
    "session_secure": "ESTADO: SEGURO",
    "system_verlassen": "Sistema de saída",
    "write_message": "Escreva uma mensagem",
    "onboarding_step_profile": "Perfil",
    "onboarding_step_security": "Proteção",
    "onboarding_step_backup": "Backup",
    "onboarding_step_launch": "Iniciar",
    "onboarding_loading_gaia_id": "Carregando Gaia-ID",
    "onboarding_setup_kicker": "Configuração Inicial do GaiaCom",
    "onboarding_profile_title": "Faça do GaiaCom o seu espaço.",
    "onboarding_profile_desc": "O seu nome de exibição e avatar permanecem sob controle local e podem ser alterados no perfil a qualquer momento.",
    "onboarding_security_title": "O que o GaiaCom protege para você agora mesmo.",
    "onboarding_security_desc": "O GaiaCom separa identidade, chaves, mensagens e status de rede. Você vê apenas a versão resumida do usuário aqui.",
    "onboarding_backup_title": "Um backup é a sua verdadeira saída de emergência.",
    "onboarding_backup_desc": "Sem dados de recuperação, ninguém pode resgatar a sua identidade. Esse é exatamente o ponto da segurança de ponta a ponta real.",
    "onboarding_launch_title": "Pronto. O que você quer fazer primeiro?",
    "onboarding_launch_desc": "Você pode começar imediatamente ou encerrar o tour e continuar a trabalhar no painel.",
    "onboarding_display_name": "Nome de exibição",
    "onboarding_display_name_placeholder": "Como o GaiaCom deve exibir você?",
    "onboarding_select_avatar": "Selecionar avatar",
    "onboarding_sec_identity_title": "Identidade",
    "onboarding_sec_identity_desc": "A sua Gaia-ID é a sua âncora de rede. Os contatos podem detectar trocas de chaves.",
    "onboarding_sec_messages_title": "Mensagens",
    "onboarding_sec_messages_desc": "O conteúdo é decifrado localmente. Mensagens editadas recebem novas assinaturas.",
    "onboarding_sec_network_title": "Rede",
    "onboarding_sec_network_desc": "O Centro de Segurança e o Centro de Denúncias tornam os riscos visíveis, sem portas dos fundos globais.",
    "onboarding_sec_transparency_title": "Transparência",
    "onboarding_sec_transparency_desc": "Registra eventos de segurança no protocolo para que os avisos permaneçam rastreáveis.",
    "onboarding_backup_notice_title": "Importante para usuários comuns",
    "onboarding_backup_notice_desc": "Guarde os seus dados de recuperação separados deste dispositivo. Caso perca a senha e o backup, o GaiaCom permanecerá bloqueado de propósito.",
    "onboarding_backup_consent": "Sei que meu backup é crucial para a recuperação e troca de dispositivo.",
    "onboarding_inbox_title": "Bandeja de entrada",
    "onboarding_inbox_desc": "Ler e-mails e escrever a primeira mensagem.",
    "onboarding_contacts_title": "Contatos",
    "onboarding_contacts_desc": "Verificar o primeiro contato ou iniciar um chat.",
    "onboarding_channels_title": "Canais",
    "onboarding_channels_desc": "Descobrir frequências públicas.",
    "onboarding_security_title_card": "Centro de Segurança",
    "onboarding_security_desc_card": "Visualizar status do GaiaShield.",
    "onboarding_later": "Mais tarde",
    "onboarding_back": "Voltar",
    "onboarding_continue": "Continuar",
    "onboarding_complete_setup": "Concluir configuração",
    "auth_legal_consent": "Li e aceito a política de privacidade e os termos de uso.",
    "auth_show_terms": "Mostrar termos de uso",
    "auth_recovery_mode": "Modo de recuperação",
    "auth_recovery_import_title": "Importar arquivo de recuperação",
    "auth_recovery_import_desc": "Restaure suas chaves GaiaCom a partir de um arquivo de backup protegido por senha. Depois, o mnemônico e o nome de usuário serão pré-preenchidos.",
    "auth_recovery_file_pwd_placeholder": "Senha do arquivo de recuperação",
    "auth_recovery_local_pwd_placeholder": "Nova senha de desbloqueio local mín. 12 caracteres",
    "auth_recovery_importing": "Importando...",
    "auth_recovery_decrypt": "Decifrar recuperação",
    "auth_back_to_login": "Voltar ao login",
    "auth_terms_title": "Termos de uso do GaiaCom Beta",
    "auth_terms_close": "Fechar",
    "auth_cookie_title": "O GaiaCOM permanece soberano.",
    "auth_cookie_desc": "Usamos apenas o armazenamento local tecnicamente necessário para idioma, sessão e segurança. Sem rastreamento, sem cookies de publicidade, sem perfis de terceiros.",
    "auth_cookie_accept": "Entendido",
    "sc_explainer_title": "O que realmente é protegido aqui?",
    "sc_explainer_desc": "O GaiaShield é a camada protetora entre a sua conta, as suas mensagens e a rede. Ele não decide sobre conteúdos, mas sobre riscos técnicos: manipulação, tentativas de reprodução, acesso não autorizado, padrões de login suspeitos e transições de gateway inseguras.",
    "sc_explainer_identity_desc": "Verifica anomalias de login, riscos de sessão e acesso a outras identidades.",
    "sc_explainer_messages_desc": "Detecta padrões de reprodução, envelopes manipulados e falta de recursos de integridade.",
    "sc_explainer_network_desc": "Sinaliza riscos de federação, limite de taxa e SMTP antes que a confiança seja incorretamente exibida.",
    "sc_open_security_warnings": "Avisos de segurança abertos",
    "sc_opt_all": "Todos",
    "sc_opt_low": "Baixo",
    "sc_opt_medium": "Médio",
    "sc_opt_high": "Alto",
    "sc_opt_critical": "Crítico",
    "sc_opt_failed_login": "Falha de login",
    "sc_opt_auth_attack": "Ataque de autenticação",
    "sc_opt_rate_limit": "Limite de taxa",
    "sc_opt_policy_violation": "Aviso de política",
    "sc_opt_message_replay": "Reprodução de mensagem",
    "sc_node_security_data_unavailable": "Dados de segurança do nó indisponíveis",
    "sc_total_events": "Total de eventos",
    "sc_login_attacks": "Ataques de login",
    "sc_rate_limits_active": "Limites de taxa ativos",
    "sc_smtp_shield_hits": "Impactos do SMTP Shield",
    "sc_top_event_categories": "Principais categorias de eventos",
    "sc_no_entries": "Sem entradas.",
    "sc_node_audit_log": "Registro de auditoria do nó (recentes)",
    "sc_no_node_events": "Nenhum evento de nó.",
    "archiv": "Arquivo",
    "entwuerfe": "Rascunhos",
    "markiert": "Favoritos",
    "wichtig": "Importantes",
    "snoozed": "Adiados",
    "papierkorb": "Lixeira",
    "spam": "Spam",
    "cancel": "Cancelar",
    "error": "Erro",
    "success": "Sucesso",
    "kopieren": "Copiar",
    "block_contact": "Bloquear contato",
    "unblock_contact": "Desbloquear contato",
    "report_contact": "Denunciar contato",
    "check_fingerprint": "Verificar impressão digital",
    "export_encrypted": "Exportar (Cifrado)",
    "export_gaiaproof": "Exportar (GaiaProof)",
    "export_password_prompt": "Por favor, insira uma senha para cifrar a exportação do chat:",
    "export_success": "Chat exportado e cifrado com sucesso.",
    "export_failed": "Falha na exportação: ",
    "gaiaproof_export_success": "Pacote GaiaProof exportado com sucesso.",
    "gaiaproof_export_failed": "Falha na exportação do GaiaProof: ",
    "export_gaiaproof_confirm": "Deseja baixar o pacote GaiaProof com todas as assinaturas e recibos de entrega do servidor? Isso pode levar um momento.",
    "group_settings_is_private": "Sala privada (não pesquisável publicamente, apenas por solicitações de entrada)",
    "group_settings_read_only": "Modo somente leitura (apenas o proprietário e os administradores podem enviar mensagens)",
    "group_settings_slow_mode": "Modo lento (tempo de espera para envio)",
    "gsn_title": "Feed social GSN",
    "gsn_node_feed": "Feed do nó",
    "gsn_following_feed": "Seguindo",
    "gsn_feed_empty": "Nenhuma publicação encontrada.",
    "gsn_composer_placeholder": "O que há de novo na federação?",
    "gsn_post_btn": "Compartilhar",
    "gsn_profile": "Perfil de usuário",
    "gsn_followers": "Seguidores",
    "gsn_following": "Seguindo",
    "gsn_bio": "Descrição / Bio:",
    "gsn_bio_label": "Descrição / Bio",
    "gsn_display_name": "Nome de exibição",
    "gsn_edit_profile": "Editar perfil",
    "gsn_save_profile": "Salvar",
    "gsn_add_image": "Adicionar imagem (Cifrado)",
    "gsn_add_emoji": "Inserir emoji",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Seguir",
    "gsn_unfollow": "Deixar de seguir",
    "gsn_repost": "Compartilhar / Repostar",
    "gsn_post_created": "Publicação compartilhada com sucesso.",
    "gsn_image_uploaded": "Imagem cifrada e enviada.",
    "gsn_upload_failed": "Falha no envio da imagem: ",
    "gsn_comment_placeholder": "Escreva um comentário...",
    "gsn_delete_confirm_title": "Excluir publicação?",
    "gsn_delete_confirm_desc": "Tem certeza de que deseja excluir permanentemente esta publicação?",
    "gsn_delete_comment_confirm_title": "Excluir comentário?",
    "gsn_delete_comment_confirm_desc": "Tem certeza de que deseja excluir permanentemente este comentário?",
    "gsn_report": "Denunciar",
    "gsn_report_title": "Denunciar violação",
    "gsn_report_category": "Categoria",
    "gsn_report_spam": "Spam / Publicidade",
    "gsn_report_harassment": "Assédio / Discurso de ódio",
    "gsn_report_abuse": "Abuso",
    "gsn_report_illegal": "Conteúdo ilegal",
    "gsn_report_severity": "Gravidade",
    "gsn_report_low": "Baixa",
    "gsn_report_medium": "Média",
    "gsn_report_high": "Alta",
    "gsn_report_comment": "Comentário adicional",
    "gsn_report_submit": "Denunciar",
    "gsn_report_submitted": "Denúncia enviada para a governança.",
    "gsn_report_post": "Denunciar publicação",
    "report_group": "Denunciar grupo",
    "report_group_reason_prompt": "Por favor, insira um motivo para a denúncia (opcional):",
    "report_reason_prompt": "Por favor, insira um motivo para a denúncia (opcional):",
    "report_failed": "Falha na denúncia: ",
    "report_success": "Contato denunciado com sucesso.",
    "room_read_only_placeholder": "Apenas o proprietário e os administradores podem escrever",
    "read_only_active": "Modo somente leitura",
    "slow_mode_active": "Modo lento ativo",
    "kommandozentrale": "Centro de comando",
    "kontakt_blockiert": "Contato bockado",
    "kontakt_freigegeben": "Contato desbloqueado",
    "mailbox_settings_title": "Configurações do correio",
    "mailbox_settings_desc": "Gerenciar assinatura, idioma, filtros de correio.",
    "mic_access_denied": "Acesso ao microfone negado: ",
    "no_frequencies_active_desc": "Crie uma nova sala para começar a se comunicar.",
    "key_changed_warning_title": "AVISO DE SEGURANÇA:",
    "key_changed_warning_desc": "A chave de identidade deste remetente foi atualizada ou difere da chave conhecida anteriormente. Por favor, verifique a impressão digital por outro canal seguro.",
    "sc_col_category": "Categoria",
    "search_members": "Pesquisar membros...",
    "tab_general": "Geral",
    "tab_members": "Membros",
    "tab_requests": "Solicitações",
    "tab_invites": "Convites",
    "tab_logs": "Registros",
    "auth_why_gaiacom": "Por que GaiaCOM?",
    "auth_why_gaiacom_desc": "A alternativa segura e descentralizada para sua comunicação confidencial.",
    "auth_self_managed_id": "ID autogerida",
    "auth_self_managed_id_desc": "Crie instantaneamente identidades criptográficas seguras sem fornecer e-mail ou telefone.",
    "auth_gaiadrop_secure_exchange": "Troca segura sem conta",
    "auth_gaiadrop_benefit_e2ee": "Criptografado de ponta a ponta",
    "auth_gaiadrop_benefit_no_login": "Nenhum login necessário",
    "auth_gaiadrop_benefit_inbox": "Entrega direta na caixa de entrada do destinatário",
    "auth_terms_of_use": "Termos de uso",
    "auth_terms_of_use_show": "Mostrar termos de uso",
    "auth_consent_privacy_terms": "Li e concordo com a política de privacidade e os termos de uso.",
    "auth_recovery_import_file": "Importar arquivo de recuperação",
    "auth_recovery_password": "Senha do arquivo de recuperação",
    "auth_recovery_local_password": "Nova senha de desbloqueio local mín. 12 caracteres",
    "auth_recovery_decrypting": "Decifrando recuperação...",
    "auth_recovery_back": "Voltar para o login",
    "auth_cookie_sovereign": "GaiaCOM permanece soberano.",
    "auth_cookie_sovereign_desc": "Usamos apenas recursos de armazenamento local tecnicamente necessários para idioma, sessão e segurança. Sem rastreamento, sem cookies de publicidade, sem perfis de terceiros.",
    "auth_cookie_sovereign_accept": "Entendido",
    "unlock_keyboard_toggle": "⌨️ Usar teclado",
    "unlock_keypad_toggle": "🔢 Usar teclado PIN",
    "unlock_status_denied": "ACESSO NEGADO / REENTRAR",
    "unlock_status_decrypting": "DECIFRANDO COFRE...",
    "unlock_status_secured": "COFRE SEGURO / BLOQUEADO",
    "auth_landing_nav_legal": "Avisos Legais",
    "auth_landing_nav_beta": "Teste Beta",
    "auth_landing_card1_title": "Criptografia Pós-Quântica (ML-KEM)",
    "auth_landing_card2_title": "100% Descentralizado",
    "auth_landing_card3_title": "Conhecimento Zero",
    "auth_landing_card4_title": "Proteção de Metadados",
    "auth_landing_card5_title": "Identidade Autogerida",
    "auth_landing_hybrid_title": "Criptografia de hoje com proteção para o amanhã.",
    "auth_landing_hybrid_desc": "GaiaCom combina o clássico e comprovado intercâmbio de chaves com o encapsulamento pós-quântico. Sem escolhas cegas: defesa em profundidade.",
    "auth_landing_x25519_desc": "Intercâmbio de chaves em curva elíptica rápido e comprovado para dispositivos atuais e sessões seguras.",
    "auth_landing_mlkem_desc": "Encapsulamento pós-quântico para confidencialidade a longo prazo contra cenários de decifração posterior.",
    "auth_landing_cycle_title": "O servidor não vê nada. A rede apenas transporta ruído.",
    "auth_landing_step1_title": "Criptografia Local",
    "auth_landing_step1_desc": "A mensagem é cifrada no dispositivo do remetente, antes de chegar à rede ou ao servidor.",
    "auth_landing_step2_title": "Transporte como Blob",
    "auth_landing_step2_desc": "O pacote viaja como ruído criptográfico através de nós federados ou camadas de armazenamento descentralizadas.",
    "auth_landing_step3_title": "Armazenamento Federado",
    "auth_landing_step3_desc": "Nenhuma caixa de correio central como alvo. Os dados estão fragmentados, federados ou descentralizados e totalmente cifrados.",
    "auth_landing_step4_title": "Decriptação Local",
    "auth_landing_step4_desc": "Apenas a chave privada do destinatário pode converter o blob de volta em conteúdo legível.",
    "auth_landing_trinity_title": "Um conceito de protocolo. Três níveis de infraestrutura.",
    "auth_landing_enterprise_desc": "Para empresas, escritórios de advocacia, médias empresas, indústria e private banking. Círculos fechados com controlo administrativo, conformidade e suporte.",
    "auth_landing_enterprise_list1": "Soberania interna e administração de utilizadores",
    "auth_landing_enterprise_list2": "Nó auto-hospedado ou cluster soberano gerido",
    "auth_landing_enterprise_list3": "SLA, suporte e módulos premium",
    "auth_landing_network_desc": "A rede aberta para a privacidade digital. Sem comércio de dados, mas infraestrutura para comunicação livre e cifrada.",
    "auth_landing_network_list1": "Cliente de código aberto",
    "auth_landing_network_list2": "Nós federados",
    "auth_landing_network_list3": "Sem chaves centrais de decriptação",
    "auth_landing_defend_desc": "Infraestrutura de alta segurança especializada para autoridades, infraestruturas críticas e silos de comunicação isolados.",
    "auth_landing_defend_list1": "Implantações isoladas e desconectadas (air-gapped)",
    "auth_landing_defend_list2": "Marca branca e auditoria de código-fonte",
    "auth_landing_defend_list3": "Soberania digital nacional",
    "auth_landing_gov_title": "Protocolo aberto. Execução comercial. Clara separação jurídica.",
    "auth_landing_gov_desc": "GaiaCom separa o protocolo aberto, os clientes abertos e a infraestrutura premium comercial. A confiança vem da transparência; as receitas, de operações empresariais, suporte, integrações e módulos especiais.",
    "auth_landing_price1_desc": "Taxa de proteção contra bots para distribuição na AppStore/PlayStore.",
    "auth_landing_price2_desc": "Código aberto para utilizadores que preferem compilá-lo eles mesmos.",
    "auth_landing_price3_desc": "Para médias empresas, escritórios de advocacia e equipas sensíveis.",
    "auth_landing_price4_desc": "Para empresas, clusters de alta disponibilidade, LDAP e acesso root.",
    "auth_landing_license1_desc": "Máxima transparência para utilizadores, bifurcações e auditorias da comunidade.",
    "auth_landing_license2_desc": "Proteção copyleft contra roubo na nuvem e bifurcações de protocolo fechadas.",
    "auth_landing_license3_desc": "LDAP, acesso root, auditoria, SLA e lógica de negócio especializada.",
    "auth_landing_final_title": "Comunicação segundo o modelo de confiança zero.",
    "auth_landing_final_desc": "GaiaCom não substitui simplesmente o e-mail. Levanta a questão de por que a comunicação confidencial ainda se baseia em caixas de correio centrais, servidores legíveis e pressupostos de há 40 anos.",
    "auth_landing_final_note": "Nota: Esta página descreve uma visão arquitetónica e roteiro. As promessas de segurança devem ser confirmadas por implementação, auditorias e testes reais antes do seu uso produtivo."




  };

export default pt;